export default {"src":"/_next/static/media/able-city.48a086de.svg","height":47,"width":132,"blurWidth":0,"blurHeight":0};